import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { isEmpty } from 'lodash'

import { ReactComponent as CloseIcon } from '../assets/icons/sidebar-modal-close.svg'

import styles from './SidebarModal.module.scss'

const SidebarModal = ({ show, isShowClear, clearCart, title, subTitle, alignment, leftAccessory, rightAccessory, onClose, children, className }) => {
  const classNames = cn(styles.sidebarModal, className)
  let subTitleElement = null

  if (!show) return null

  if (!isEmpty(subTitle)) {
    subTitleElement = (
      <div className={styles.headerRow}>
        <h2>{subTitle}</h2>
      </div>
    )
  }

  return (
    <div className={classNames}>
      <div className={styles.overlay}></div>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.headerRow}>
            {leftAccessory}
            <h1>{title}</h1>
            <div className={styles.clearContainer}>
              {isShowClear && (
                <span className={styles.clear} onClick={clearCart}>Clear</span>
              )}
              <CloseIcon className={styles.closeIcon} onClick={onClose} />
            </div>
          </div>
          {subTitleElement}
        </div>
        <div className={styles.body}>
          {children}
        </div>
      </div>
    </div>
  )
}

SidebarModal.defaultProps = {
  show: false,
  title: '',
  subTitle: '',
  alignment: 'right',
  leftAccessory: null,
  rightAccessory: undefined,
  onClose: () => {},
  children: undefined,
}

SidebarModal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  alignment: PropTypes.oneOf(['left', 'right']),
  leftAccessory: PropTypes.node,
  rightAccessory: PropTypes.node,
  onClose: PropTypes.func,
  children: PropTypes.node,
}

export default SidebarModal
